import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { Grid, Image } from 'semantic-ui-react';
const logo = require('./theme/img/prooph-software-logo-web1-white_var.svg');

interface Overview extends RouteComponentProps<{ id: string }>, InjectedTranslateProps {
}

const Overview = (props: Overview) => {
    // Add your containers here
    return <Grid centered={true}>
        <Grid.Row>
            <h1 className='ui header'>
                <div className='content'>
                    WELCOME TO INSPECTIO
                    <div className='sub header'>a <a href='http://prooph-software.de/'>prooph software GmbH</a> product</div>
                </div>
            </h1>
        </Grid.Row>
        <Grid.Row>
            <Image className='ui medium rounded image' src={logo} style={{width:300, height:300, backgroundColor: '#003F69', padding: '30px'}}/>
        </Grid.Row>
    </Grid>;
};

export default translate('translation')(Overview);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Overview.tsx